import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface Crumb {
  label: string;
  path?: string;
}

interface PageHeaderProps {
  title: string;
  desc?: string;
  crumbs: Crumb[];
  eyebrow?: string;
  children?: ReactNode;
}

export default function PageHeader({ title, desc, crumbs, eyebrow, children }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 pb-10 pt-28 md:px-6 md:pb-14 md:pt-36">
        <nav aria-label="面包屑导航" className="mb-5">
          <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            {crumbs.map((crumb, index) => (
              <li key={crumb.label} className="flex items-center gap-2">
                {index > 0 ? <i className="ri-arrow-right-s-line text-sm" aria-hidden="true"></i> : null}
                {crumb.path ? (
                  <Link to={crumb.path} className="transition-colors hover:text-primary-700">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700">{crumb.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        {eyebrow ? (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-700">
            <i className="ri-fire-line" aria-hidden="true"></i>
            {eyebrow}
          </span>
        ) : null}

        <h1 className="mt-4 max-w-3xl text-3xl leading-tight text-foreground-950 md:text-5xl">{title}</h1>
        {desc ? (
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
        ) : null}
        {children ? <div className="mt-6">{children}</div> : null}
      </div>
    </section>
  );
}